import React from "react";
import { motion } from "framer-motion";
import "./speech.css";
import { div } from "framer-motion/client";

function Speech() {
  return (
    <>
      <h2 className="speech-therapy-heading">⮚	Speech and Language Therapy</h2>

    <motion.div
      initial={{ x: "-100vw", opacity: 0 }} // Start off-screen (left)
      animate={{ x: 0, opacity: 1 }} // Move to its final position
      transition={{ type: "tween", duration: 3 }} // Smooth transition
    >
      <div className="container">
        <p>Deepti Centre has a well established Department of Speech and Language Therapy. The Department’s service is very helpful and essential for the all round progress of the children at Deepti. Speech Therapy is given to students with speech, language and communication impairments. It increases the level of children’s confidence for verbal communication. The main focus is to improve their comprehension and expression of the lexical items, vocabulary, functional communication skills, articulation and speech intelligibility of the children. Goals are set based on the level of performance of each child. Through individual and group therapy sessions, significant improvement in vocabulary and comprehension has been observed in most of the children.</p>
      </div>
    </motion.div>
    </>
  );
}

export default Speech;
